// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectTypeAhead__select__a6JgV"};